export default {
  validate: {
    nin_required: 'Fødselsnummer er nødvendig.',
    phone_not_valid: 'Telefonnummeret er ikke gyldig. Godkjente formater: XXXXXXXX, +47XXXXXXXX og utenlandske.',
    name_required: 'Navn er nødvendig.',
    first_name_required: 'Fornavn er nødvendig.',
    last_name_required: 'Etternavn er nødvendig.',
    emoji_not_allowed: 'Emoji er ikke tillatt.',
    email_required: 'E-post er nødvendig.',
    email_not_valid: 'E-postaddressen er ikke gyldig.',
    amount_required: 'Et beløp er nødvendig.',
    only_numbers_allowed: 'Kun tall er tillatt.',
    date_not_valid: 'Datoen er ikke gyldig. Forventet format: YYYY-MM-DD',
    min_amount: 'Minimumbeløpet er {amount} kr.',
  },
  forms: {
    first_name: 'Fornavn',
    last_name: 'Etternavn',
    email: 'E-post',
    phone: 'Telefonnummer',
    didYouMean: 'Mente du',
    btnSign: 'Skriv under',
    btnWait: 'Vent litt...',
    fieldRequired: 'Du må fylle ut feltet.',
    onlyNumbers: 'Kun tall er tillatt.',
    one_time_donation: 'Engangsbidrag',
    monthly_donation: 'Månedlig bidrag',
    recommended: 'Anbefalt',
    amount: 'Beløp',
    otherAmount: 'Annet',
    donate_monthly_with: 'Bidra månedlig med',
    donate_with: 'Bidra med',
    choose_amount_notice: 'Velg et praktisk, men betydelig beløp for deg.',
    error: {
      title: 'En feil har oppstått',
      description: 'Prøv igjen. Om problemet fortsetter kontakt oss på {email}',
    },
    success: {
      title: 'Handling lagret!',
    },
    noEmoji: 'Du kan ikke ha emojis i feltet.',
    privacyNotice: 'Beskyttelse av dine personopplysninger er ekstremt viktig for oss. Du finner mer informasjon om hvordan vi behandler dataene dine i vår',
    privacyNoticeBtnLabel: 'personvernerklæring',
  },
  privacyPolicy: {
    title: 'Personvernerklæring',
    btnLabel: 'Personvernerklæring',
    errorMessages: 'En feil oppstod. Se vår nettside for mer informasjon: {website}',
  },
  salesTerms: {
    title: 'Salgsbetingelser',
    btnLabel: 'Salgsbetingelser',
    errorMessages: 'En feil oppstod. Se vår nettside for mer informasjon: {website}',
  },
  shared: {
    wait: 'Vent litt...',
    animalFriend: 'dyrevenn',
    or: 'eller',
    and: 'og',
  },
  modalWhoArewe: {
    title: 'Hvem er vi?',
    btn: 'Hvem er vi?',
    text: 'Anima - Stopp dyremishandling er en organisasjon som jobber for å stoppe dyremishandling på nasjonalt og internasjonalt nivå gjennom blant annet redningsaksjoner av dyr i nød, informasjonsvirksomhet, samarbeid med næringslivet, politisk arbeid og fredelige kampanjer. Anima er en del av den internasjonale dyrevernorganisasjonen “Anima International” som har avdelinger i Norge, Danmark, England, Polen, Bulgaria og Frankrike. <br><br> Har du spørsmål? Ta kontakt over e-post på {email} eller over tlf på {phone}',
    info: 'Org.nr. {org_number} | {address} | Kontonr. {bank_account}',
  },
  donate: {
    title: 'Støtt fuglene',
    subTitle: 'Kyllingene venter på din hjelp {name}',
    textHero: 'Lidende dyr trenger ditt engasjement og drivkraft.',
    supportTrue: 'Støtter allerede',
    supportFalse: 'Støtter ikke enda',
    giveGift: 'Gi en spesiell gave - hjelp kyllingene.',
    becomeDonor: 'Støtt kampen hver måned og vis at du bryr deg om dyrene.',
    reasonsGift: '3 grunner til å gi en spesiell gave akkurat nå',
    reasonsDonor: '3 grunner til å gi et månedlig bidrag akkurat nå',
    myGift: 'Min spesielle gave!',
    myDonor: 'Mitt månedlige bidrag!',
    changeToGift: 'Bytt til engangsbidrag',
    changeToDonor: 'Bytt til månedlig bidrag',
    chooseAmount: 'Velg et beløp som er mulig og meningsfullt for deg.',
    minimumAmount: 'Du kan ikke gi mindre enn {amount} {currency}.',
    chooseCustomAmount: 'Du kan skrive in et eget beløp under.',
    btnSkip: 'Hopp over, jeg vil ikke støtte nå',
    btnChooseAmount: 'Velg et beløp',
    btnOneTime: 'Bidra {amount} {currency} med',
    btnMonthly: 'Bidra {amount} {currency} månedlig med',
    progressBar: {
      helpUsReach: 'Hjelp oss å nå målet vårt',
      areDonors: 'donerer allerede',
    },
    countdown: {
      timeLeft: 'Tid igjen for å nå målet',
      days: 'dager',
      hours: 'timer',
      minutes: 'minutter',
      seconds: 'sekunder',
    },
    explainer: {
      title: 'Hva vil bidraget ditt bety for kyllinger?',
      text: 'Med ditt bidrag kan du sikre en bedre fremtid for fuglene. <b>Bare folk som deg</b> kan kjempe for å <b>stoppe deres lidelse</b>. Sørg for at { company } og andre bedrifter slutter å selge turbokylling og få <b>slutt på de grusomme forholdene</b>. Det er kun med bidrag fra ildsjeler som deg, {name} at vi kan <b>fortsette arbeidet for dyr som lider.</b>',
    },
    reasons: {
      1: 'Takket være deg vil så <b>mange mennesker som mulig</b> lære om kyllingenes unødvendige lidelser og { company } sitt ukritiske salg av turbokylling.',
      2: 'Du vil bli <b>forkjemperen</b> til forsvarsløse skapninger.',
      3: 'Du vil sørge for at bedriften bli overveldet av en bølge av meldinger slik at det vil være <b>umulig å ignorere oss</b>.',
    },
    opinion: {
      no_buy: 'Kjøper ikke turbokylling',
      reduce: 'Reduserer forbruket',
      own_way: 'Gjør det på sin egen måte',
      none: 'Ingen mening enda',
    },
    impact: 'folk vil lære om turbokyllinger på grunn av deg.',
    modalMissingDetails: {
      title: 'Manglende personopplysninger',
      text: 'Dine personopplysninger mangler. Venligst fyll ut skjemaet på neste side, deretter kan du fortsette ditt bidrag.',
      btnLabel: 'Fyll ut skjema',
      backSoon: 'Du kommer tilbake hit når du har lagt inn din informasjon.',
    },
    modalError: {
      title: 'Det oppsto en feil, prøv på nytt',
      text: ' Kontakt oss på { email } om du fortsetter å oppleve problemer.',
      btnLabel: 'Prøv på nytt',
    },
  },
}
